import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import type { DecisionDocument, DocumentStatus } from '../api/contract'
import './DecisionDocumentation.css'
import { InfoTip } from './InfoTip'
import { Link } from 'react-router-dom'

/** The server owns the status vocabulary; this only maps it to the frozen styling. */
const STATUS: Record<DocumentStatus, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'bdg' },
  in_review: { label: 'In Review', className: 'bdg b-b' },
  completed: { label: 'Completed', className: 'bdg b-g' },
}

function DocumentCard({ doc }: { doc: DecisionDocument }) {
  const status = STATUS[doc.status]
  return (
    <div className="dc">
      <div className="dc-t">
        <div className="dc-h">{doc.title}</div>
        {doc.report_count > 0 && <span className="cbadge">{doc.report_count}</span>}
      </div>
      <div className="dc-r">
        <span className="dc-n">{doc.executive_display_name}</span>
      </div>
      {/* pill sits on the ID line, right-justified — locked 2026-07-18 */}
      <div className="dc-m">
        <span className="dc-i">{doc.executive_reference_code}</span>
        <span className={status.className}>{status.label}</span>
      </div>
      <Link className="btn btn-b" to="/decision-documentation">View Decision Documentation</Link>
    </div>
  )
}

export function DecisionDocumentation() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['decision-documents'],
    queryFn: () => api.getDecisionDocuments(),
  })

  return (
    <section className="card sec" style={{ padding: '18px 20px' }}>
      <h2 className="h2" style={{ marginBottom: 14 }}>Decision Documentation <InfoTip tip="decisionDocs" /></h2>

      {isPending && (
        <div className="rc-msg" aria-busy="true">Loading decision documentation…</div>
      )}
      {isError && (
        <div className="rc-msg" role="alert"><b>Could not load decision documentation</b></div>
      )}
      {data && data.items.length === 0 && (
        <div className="rc-msg">
          <b>No documentation yet</b>
          Reports appear here once an evaluation is underway.
        </div>
      )}

      {data && data.items.length > 0 && (
        <div className="docwrap">
          {data.items.map((doc) => <DocumentCard key={doc.id} doc={doc} />)}
          <div className="dc-all">
            <Link className="btn" to="/decision-documentation">View All Reports &nbsp;→</Link>
          </div>
        </div>
      )}
    </section>
  )
}
